// src/components/ui/dialog.js - Dialog 컴포넌트
import React from 'react';
import { X } from 'lucide-react';

// Dialog 컨테이너
export const Dialog = ({ 
  open, 
  onOpenChange, 
  children 
}) => {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onOpenChange(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm"
        onClick={handleBackdropClick}
      />
      
      {/* Dialog Content */}
      <div className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

// Dialog Content
export const DialogContent = ({ 
  children, 
  className = "",
  onClose
}) => {
  return (
    <div className={`relative p-6 ${className}`}>
      {onClose && (
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none text-gray-500 dark:text-gray-400"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>
      )}
      {children}
    </div>
  );
};

// Dialog Header
export const DialogHeader = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`flex flex-col space-y-1.5 text-center sm:text-left ${className}`}>
      {children}
    </div>
  );
};

// Dialog Title
export const DialogTitle = ({
  children,
  className = ""
}) => {
  return (
    <h2 className={`text-lg font-semibold leading-none tracking-tight text-gray-900 dark:text-white ${className}`}>
      {children}
    </h2>
  );
};

// Dialog Description
export const DialogDescription = ({
  children,
  className = ""
}) => {
  return (
    <p className={`text-sm text-gray-600 dark:text-gray-300 ${className}`}>
      {children}
    </p>
  );
};

// Dialog Footer
export const DialogFooter = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 ${className}`}>
      {children}
    </div>
  );
};